// extracted by mini-css-extract-plugin
module.exports = {"hello":"AccountLink_hello__cxOuv","name":"AccountLink_name__WMICH"};